<template>
  <div style="width: 100%;height: 100%;">
    <div style="display: flex;" :style="{height:getHeight(),marginBottom:getMarign()}" v-for="(item,index) in list"
      :key="index">
      <div :style="{width:getWordWidth(),fontSize:getWorkFontSize(),
      fontFamily:wordFont.fontFamily,color:getWordColor(index)}"
        style="display: flex;height: 100%;">
        <div style="height: 100%;display: flex;align-items: center;justify-content: center;" :style="{width:getImageColumnWidth()}">
          <img :style="{width:getImageWidth()}" :src="getImage(index)" />
        </div>
        <div style="flex: 1;height: 100%;">
          {{item.name}}
        </div>
      </div>
      <div style="flex: 1;">
        <div style="width:100%;height:100%; " :style="{background:getBackground(index)}">
          <div :style="{width:item.width,background:getBlBackground(index)}" style="height: 100%; "></div>
        </div>
      </div>
      <div :style="{width:getNumberWidth(),fontSize:getNumberFontSize(),
      fontFamily:numberFont.fontFamily,color:getNumberColor(index)}" style="padding-left: 5px;">{{item.number}}</div>
    </div>
  </div>

</template>

<script>
  import fwUtil from 'framework-util'
  import {getDataService} from '../../api/chart/chart/index.js'
  export default {
    props: {
      queryConfig:{
        type:Object,
        default(){
          return {
            url:null,
            params:[]
          }
        }
      },
      wordFont: {
        type: Object,
        default: function() {
          return {
            fontSize: 20,
            fontFamily: null,
            colors: "",
            color: "#ffffff",
            width: 50
          }
        }
      },
      //自定义图片
      customImage:{
        type:String,
        default:null
      },
      numberFont: {
        type: Object,
        default: function() {
          return {
            fontSize: 20,
            fontFamily: null,
            colors: "",
            color: "#ffffff",
            width: 50
          }
        }
      },
      rowHeight: {
        type: Number,
        default: 20
      },
      marginHeight: {
        type: Number,
        default: 20
      },

      background: {
        type: String,
        default: 'radial-gradient(circle, rgba(2, 24, 86, 0.41) 0%, rgba(4, 7, 37, 0.41) 100%)'
      },
      blBackground: {
        type: String,
        default: '#F8E84D'
      },
      backgrounds: {
        type: String,
        default: null
      },
      blBackgrounds: {
        type: String,
        default: null
      },
      chartConfig: {
        type: Object,
        default: function() {
          return {
            data: []
          };
        }
      },
      imageConfig: {
        type: Object,
        default: function() {
          return {
            columnWidth: 30,
            imageWidth: 15
          }

        }
      },
      screen: {
        type: Object,
        default () {
          return {
            height: 1920,
            width: 1280,
          };
        },
      },
      page: {
        type: Object,
        default () {
          return {
            height: 1920,
            width: 1280
          };
        },
      },
      defaultList:{
        type:Array,
        default(){
          return [
            {
              name:'test',
              number:12345,
              width:'40%'
            },
            {
              name:'test2',
              number:1235,
              width:'30%'
            }
          ]
        }
      }
    },
    data() {
      return {
        timer:null,
        list:[],
        images:['data:image/png;base64,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',
        'data:image/png;base64,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',
        'data:image/png;base64,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',
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAYAAAAe2bNZAAAABHNCSVQICAgIfAhkiAAAAwdJREFUWEe1mD1oFEEYht93Bb1gYbTwBwsTEMQqeyBCCs0FBBERDVgksUk6GzFWgk1OxDqJNnZJ410ZRewCOQsRLLy9KmWSyh9E70BJgrqfzOzt/WU3u7O72eLgbmfmnnnfb76ZbwjDx34pNizcBKSguwpsEv0iqINwvOFYgYvXzh02v8f7E8ZpZi9LP7ZxH5ApAgNx+nic2AC4hBwWnDHWo/pFwthlmYXIjJp91GBh77VqFovOOBf2GiMURquxJask7KQQvf1E4KCPo2EqBcLouKAGSazGnioJR4PiaReMAqEl1azUCBpH2xYA1AXTtGZ9PxQJsKyOPg52WtYNU3KrWcZIlLoqhpxJK++3a8HY5X9FgrNRA2T9XoQPnEnO6+ykPrKw5+kwce2Mh7q0BjyrSSxuHT9NuzyYlKoMnwTmLhMHLXMYLznKY2fiQLEJ466bZNbeKb8YJS6eaP9qooyfqZ0Ja5Bpl/L0eeDeEPH5N3DqcDJlNJDLPNNatDJGHDsEPK+JhjKNGV9PFci0S26FxEisaOtp5NtT+w5Mrwg+jaeBwbvEML49v/4AD98LPnxBJjA/TTOuWj1Phtv2LK55kqVUps582Y2XEDosKl8lzh0FPn4F7q62u6eB0UkvX3bVoedI3JiZu0SMnIZePdffdM8jJUzDKGYeXSBunwU646RzEmlgRAwD+O0NtnJJHCWD1Avr58EYbAWLV4jjfeEYftL7sQPs/AW+bXlLPs7j5ZkMD1OpbFIZWFHnS+4GiOaeG2cewW0Swwg2q5PWQCa7to+WFKZ7116Wfm7LhskSD9ImIUxDchxQx8/2Sa+kaiOZS25Ssp67Tnr+MPmyq8rRoWTDJupVq05YrbpsV3WQhV0xsVr2+O3D6qZK2viJAGqIy0JvIRdaUdKS/QIKBNEbZdgMVMXAbQ2UZQzVJMeCUa3dCWh7q6yY0raGCIt+fRQmQOSViOro3c+4MxROGWVqwaZQlpCz5jO5n+mdhXdDgQIgt7TP3pWJOg819JWHfvgKgorpzdV/vu+Qc7t27esAAAAASUVORK5CYII=',
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAYAAAAe2bNZAAAABHNCSVQICAgIfAhkiAAAAx5JREFUWEe1mD9MFEEUxr+3RjiixIsWasVBZyzYa0ho9CiNUbHzsKExsVKoTeQ0aitQqY3XeNeoYGFhxVmRoMkt0YSYGIFYqIkRLmhEjPvMzOzC3p+9nVmWLTbZ7LyZ37zvzZt5QzB87Cdsw8IFgHPSlGETIc2MdRAc1R1V4OKFc5m8b71BSKeZPcNpbOI6wKMEZHRsFCdWACoihSnnIq1H2UXC2GWeAPOYmH1UZ2H/pdcsKjiXaKpdH6Ew0hu/eY4IdlyIRjtmOOiioTAvtYSRcUESJLY32nqJaahVPDXBCBCyuJqUN1r1I2VrAVQH40mzvBceaSHZOrqoNyhZPUzJrSYZI1HeFTHkjFhZv902jF3+VyDQRFQHSf9npnFnhCZldhIvU3mu9RNGT4RjLXwDrs6xFreMH08uBWPolbuDhDM9wM+/wMZW85jOd+DGvB6MSo58y8nvK3gw7rJJZn0wRBg4Cph4oJ2bRKZ28lYvxVnKScNI77iUJVOJhOGewDCNk11yK0Q4rRVtXqPnZwmZbuDpR+DeW/3YaCsV43UsmJfnCMcPAMUlYHoxWZg104zrwwRn+uMP8HkDePSeMf/VxM+qrVjilC27xlMTMnVaOwMe6QI6vO8tF3j4jvF4yRxIwIhDzyFz03oLkQjP9wGHO1X+OfXMeI61WDETBj7cB9wcUDuMaTxx3ABu58W4wa1gDLeCKDnjw4g8k+BhKijT7QXG7Kco9J3/MgOLz2zJXQGhR8d08Jhq1bh8gwH8YQ3IvzIIYMZqdcTKGO/a/vEhuGN3dwAH9yvIL7+AO2/Mck39rj3DadrkFZ0lLqS4cpIQzC0+hOnRwVOixinKiOPnzkmvJGojvq8jVZJtmk56fufZsivK0f4kB4voa7Gat7brsqbqQFeuBIC35fH7CqubKjrxswugGruUayzkQitKsnivgFqCiIm1rbVpUwIlGUOLnKKcUa0ddL+tVllhl7LVmKng10dh8kZeiQhDdT/jjhHTqG6mlgMyVpm4iJQ1mcj9TOMs1A0FcgAPS53VlYk4D9XklYd8aBaMiunN1X+q73lz6ZvHgwAAAABJRU5ErkJggg==' ],
        defaultImage:'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAAABHNCSVQICAgIfAhkiAAAAkpJREFUSEuVlU9O21AQxmfGfwAJqeEGcILaG6SQLpoTwBHoCUpPUI4QTgC9ATco3MCsUNjEG6dNssCsKiXYU70/efZ7sePgTSTb+ebzb743g9B2TV57wXJ1TowXVNIxlhB5TIAlJsSUAtM9gPeYxwdpmwQ2PQjHs2sA+A4APVKC4P7KQgXmyDR69/dv8hhzV8sWn7z2wuXyNwBE6xeRtXBhFyC7YMJA3xanYVIvUIkr4Ylwa7+AynlJ4AiaLxL3kSn333GYDaoCRjwcz0TVzxuYGAwSzbxCVCpk5j5QsvcvGKZDhUiKa8Y/m/gjaOcOe828oRd4k50FV0q8BUe9kGzmduYVogIhJP8k7WOKwcv8EplvWyMpHIimdjA3aZKo6Ef2xRthOJ7dA8B5l7jFdo3IZW7QeUk28GIh3tzIWjUTx1r82pmrJmcDH4U4b3OtGlPFcX2gWmOpe7OzuCiwbupGHNnJf+lJ51PtvBOLdK+RWI4bmZM0Mj1TWDobapw7M4aceJqmMz5N+0G0UxSlcx3H+hBrRFTIEysPEu4//zkuiQSaT1vjKJqq/tg+JeUM8gC4OPnbP0g7j78pqGfMRko0GnXfAyjw17y/d2lmix4BD42DS6s3zRgpqJuqT+ibV0AkXFfiABC8zCNkFgVa8ThCm4hKjhenh2amW8tCF7hr+4LGEaB68OYjfl3ElbDl3LAVu3O1ukZmseasSyXG3kiCMUF5lcdHHWuuJiVSxIgXjCiaI5dIbcY8EdCDv4RRHh99bEF3zZpdn/8HmLh7J++MhIgAAAAASUVORK5CYII='
      }
    },
    watch: {

      queryConfig:{
        handler(newValue, oldValue) {
          this.getData()
        },
        deep: true
      }
    },
    computed: {

    },
    mounted() {
      this.getData()
       if(this.timer!=null){
         clearInterval(this.timer)
         this.timer=null
       }
       let that=this
       this.timer=setInterval(function(){
         that.getData()
       },1000*60*5)
    },
    beforeDestroy() {
      if(this.timer!=null){
        clearInterval(this.timer)
        this.timer=null
      }
    },
    methods: {
      getData(){
        let that=this
        that.list=[]
        if(this.queryConfig && this.queryConfig.url){
          let url=this.queryConfig.url
          let params={}
          if(this.queryConfig.params){
            for(let i=0;i<this.queryConfig.params.length;i++){
              if(this.queryConfig.params[i].target
               && this.queryConfig.params[i].source){
                 let _value=fwUtil.Helper.GetQueryString(this.queryConfig.params[i].source)
                 if(_value){
                   params[this.queryConfig.params[i].target]=_value
                 }
               }
            }
          }
          getDataService(url,params).then((res)=>{
            that.list=res
          })

        }else{
          that.list=that.defaultList
        }
      },
      getImage(index){
        let _image=this.defaultImage
        if (index < this.images.length) {
          _image = this.images[index]
        }
        if(this.customImage){
          let _custom=this.customImage.split("###")
            if (index < this._custom.length) {
              _image = this._custom[index]
            }
        }
        return _image;
      },
      getBackground(index) {
        let _color = this.background
        if (this.backgrounds) {
          let _colors = this.backgrounds.split("###")
          if (index < _colors.length) {
            _color = _colors[index]
          }
        }
        return _color
      },
      getBlBackground(index) {
        let _color = this.blBackground
        if (this.blBackgrounds) {
          let _colors = this.blBackgrounds.split("###")
          if (index < _colors.length) {
            _color = _colors[index]
          }
        }
        return _color
      },
      getWorkFontSize() {
        let _height = this.wordFont.fontSize ? this.wordFont.fontSize : 14
        let height = (_height / this.page.width) * this.screen.width;
        return height + 'px'
      },
      getNumberFontSize() {
        let _height = this.numberFont.fontSize ? this.numberFont.fontSize : 14
        let height = (_height / this.page.width) * this.screen.width;
        return height + 'px'
      },
      getWordColor(index) {
        let _color = this.wordFont.color
        if (this.wordFont.colors) {
          let _colors = this.wordFont.colors.split("###")
          if (index < _colors.length) {
            _color = _colors[index]
          }
        }
        return _color
      },
      getNumberColor(index) {
        let _color = this.numberFont.color
        if (this.numberFont.colors) {
          let _colors = this.numberFont.colors.split("###")
          if (index < _colors.length) {
            _color = _colors[index]
          }
        }
        return _color
      },
      getHeight() {
        let _height = this.rowHeight ? this.rowHeight : 40
        let height = (_height / this.page.height) * this.screen.height;
        return height + 'px'
      },
      getMarign() {
        let _height = this.marginHeight ? this.marginHeight : 40
        let height = (_height / this.page.height) * this.screen.height;
        return height + 'px'
      },
      getImageColumnWidth() {
        let _width = this.imageConfig.columnWidth ? this.imageConfig.columnWidth : 20;
        let width = (_width / this.page.width) * this.screen.width;
        return width + "px";
      },
      getImageWidth() {
        let _width = this.imageConfig.imageWidth ? this.imageConfig.imageWidth : 20;
        let width = (_width / this.page.width) * this.screen.width;
        return width + "px";
      },
      getWordWidth() {
        let _width = this.wordFont.width ? this.wordFont.width : 50;
        let width = (_width / this.page.width) * this.screen.width;
        return width + "px";
      },
      getNumberWidth() {
        let _width = this.numberFont.width ? this.numberFont.width : 50;
        let width = (_width / this.page.width) * this.screen.width;
        return width + "px";
      },

      calWidth() {
        if (this.chartConfig.maxValue > 0) {
          return (this.chartConfig.value / this.chartConfig.maxValue * 100) + "%"
        }
        return '0'
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/process/CustomProcess.vue